import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { Link } from 'components/core';

export function LegalFooter(): JSX.Element {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      {t(
        'dutchiePay.moreInfo',
        `Dutchie uses MX to connect with your bank. By creating an account, you agree to these`
      )}
      <Link href='https://try.dutchie.com/digital-money-management-user-terms/'>
        <LinkText
          href='https://try.dutchie.com/digital-money-management-user-terms/'
          target='_blank'
          aria-label='terms'
        >
          {t('common.moreInfo', 'terms')}
        </LinkText>
      </Link>
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  justify-content: center;
  text-align: center;
  color: ${({ theme }) => theme?.colors?.grey[30]};
  font-size: 13px;
  margin-top: 20px;
  line-height: 20px;
`;

const LinkText = styled.a`
  color: ${({ theme }) => theme.colors.primaryBlue};
  margin-left: 3px;
`;
